import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { classNames } from '@axo/shared/util/dom';
import { lock_hooks } from '@axo/shared/data-access/hooks';
import { HumanReadableID } from '../../HumanReadableID';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';

export function useMyLocksNodes(marketCountry: string): MenuNode[] {
  const navigate = useNavigate();

  const unlock = lock_hooks.useUnlockApplications(marketCountry);
  const locks = lock_hooks.useCurrentUserLocks(marketCountry);

  const ids = useMemo(
    () => locks.data?.Items.map((lock) => lock.LoanApplicationID) ?? [],
    [locks.data?.Items],
  );

  const nodes = useMemo<MenuNode[]>(
    () => [
      ...ids.map((id) => ({
        id: 'my-locks/' + id,
        label: <HumanReadableID id={id} />,
        className: styles.clickable,
        nodeData: {
          onClick: () => navigate(`/application/${id}`),
        },
      })),

      {
        id: 'F4ABE982-4E20-404A-945D-3F0501E26092',
        label: 'Release locks',
        icon: 'unlock',
        disabled: ids.length === 0,
        className: classNames(styles.clickable, styles.action),
        nodeData: {
          onClick: () => unlock.mutate(ids),
        },
      },
    ],
    [ids, navigate, unlock],
  );

  return useMemo(
    () => [
      {
        id: 'A68B65DD-C0E6-4EF4-BBE4-A61795EAA99D',
        hasCaret: true,
        icon: 'lock',
        label: 'My locks',
        secondaryLabel: `(${ids.length})`,
        className: styles.clickable,
        childNodes: nodes,
      },
    ],
    [nodes, ids.length],
  );
}
